/**
 * Stock-related runtime constants safe to import from the browser.
 *
 * Live in `@repo/utils` (non `@repo/api`) perché sono valori runtime usati
 * dal frontend (`<ComboboxForm>`, `z.nativeEnum(...)`, `Object.values(...)`)
 * e `@repo/api` è un workspace package CommonJS che Vite serve direttamente:
 * gli enum esportati da lì funzionano solo come type, non come valore.
 */
export const AdjustmentReason = {
    INVENTORY_COUNT: 'INVENTORY_COUNT',
    DAMAGED: 'DAMAGED',
    LOST: 'LOST',
    FOUND: 'FOUND',
    CORRECTION: 'CORRECTION',
    OTHER: 'OTHER',
};
export const ADJUSTMENT_REASON_VALUES = Object.values(AdjustmentReason);
//# sourceMappingURL=stock.js.map